import { useState } from 'react';
import { Input, Label, Message, Slider } from '@iwoca/orion';

import {
  MAX_WITHDRAWAL_FEE,
  MIN_WITHDRAWAL_FEE,
} from '../filterConfigs.helper';
import standAloneCalculatorStyles from '../StandAloneCalculator.module.css';

import styles from './WithdrawalFeeFilter.module.css';

type TProps = {
  value: string;
  onChange: (withdrawalFee: string) => void;
};

export const WithdrawalFeeFilter = ({ value, onChange }: TProps) => {
  const [error, setError] = useState<string | null>();

  const handleBlur = (newValue: string) => {
    setError(null);
    if (Number(newValue) > Number(MAX_WITHDRAWAL_FEE)) {
      onChange(MAX_WITHDRAWAL_FEE);
    } else if (Number(newValue) < Number(MIN_WITHDRAWAL_FEE)) {
      onChange(MIN_WITHDRAWAL_FEE);
    }
  };

  const handleIntegerChange = (value: string) => {
    const valueAsInteger = value
      .replace(/[^0-9.]/g, '')
      .replace(/(\..*)\./g, '$1');

    setError(null);

    if (Number(valueAsInteger) > Number(MAX_WITHDRAWAL_FEE)) {
      setError(`Please enter a maximum of ${MAX_WITHDRAWAL_FEE}`);
    } else if (Number(valueAsInteger) < Number(MIN_WITHDRAWAL_FEE)) {
      setError(`Please enter a minimum of ${MIN_WITHDRAWAL_FEE}`);
    }
    onChange(valueAsInteger);
  };

  return (
    <div className={styles.container}>
      <div className={styles.inputContainer}>
        <Label htmlFor="withdrawal-fee" className={styles.label}>
          Withdrawal fee
        </Label>
        <Input
          id="withdrawal-fee"
          className={styles.input}
          value={value}
          onChange={(e) => handleIntegerChange(e.target.value)}
          onBlur={(e) => handleBlur(e.target.value)}
        />
      </div>
      <Slider
        data-testid="withdrawal-fee-slider"
        labelClassName={standAloneCalculatorStyles['label']}
        min={Number(MIN_WITHDRAWAL_FEE)}
        max={Number(MAX_WITHDRAWAL_FEE)}
        leftLabel="0%"
        rightLabel={`${MAX_WITHDRAWAL_FEE}%`}
        value={value}
        step={0.5}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && (
        <Message
          className={styles.error}
          size="small"
          type="error"
          message={error}
        />
      )}
    </div>
  );
};
